/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pwf_DeniedInputs */

const en_pwf_denied = /** @type {(inputs: Pwf_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You need product admin rights to switch the workflow. Ask a product admin.`)
};

const de_pwf_denied = /** @type {(inputs: Pwf_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für den Workflow-Wechsel brauchst du Produktadmin-Rechte. Frag einen Produktadmin.`)
};

/**
* | output |
* | --- |
* | "You need product admin rights to switch the workflow. Ask a product admin." |
*
* @param {Pwf_DeniedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pwf_denied = /** @type {((inputs?: Pwf_DeniedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwf_DeniedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pwf_denied(inputs)
	return en_pwf_denied(inputs)
});